import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBook,
  faHome,
  faEye,
  faSearch,
  faBrain,
  faPalette,
  faBullseye,
  faGlobe,
  faPencilAlt,
  faPlus,
  faSave,
  faPlay,
  faArrowLeft,
  faBell,
  faUser,
  faSignInAlt,
  faSignOutAlt,
  faArrowRight,
  faChevronRight,
  faQuestionCircle,
  faExclamationTriangle,
  faSync,
  faLock,
  faWifi,
  faDownload,
  faUpload,
  faEnvelope,
  faPhone,
  faShieldAlt
} from "@fortawesome/free-solid-svg-icons";

const ROOM_LINKS_BY_SECTION = {
  3: [
    { tab: "cermati", label: "Buka Ruang Cermati" },
    { tab: "eksplorasi", label: "Buka Ruang Eksplorasi" },
  ],
  4: [{ tab: "rancang", label: "Buka Ruang Rancang" }],
  5: [{ tab: "desain", label: "Buka Ruang Desain" }],
  6: [
    { tab: "asah", label: "Buka Ruang Asah" },
    { tab: "sebar", label: "Buka Ruang Sebar" },
  ],
};

const PanduanContent = ({ onOpenRoom }) => {
  const [activeSection, setActiveSection] = useState(1);

  const manualSections = [
    {
      id: 0,
      title: "📘 PETUNJUK SINGKAT PENGGUNAAN MANUAL",
      icon: faBook,
      content: (
        <div className="manual-section-content">
          <h3>PETUNJUK SINGKAT PENGGUNAAN MANUAL</h3>
          <p>Manual ini disusun untuk membantu pengguna mengoperasikan Website Rumah CERDAS secara teknis, khususnya dalam menggunakan menu dan fitur yang tersedia di dalam sistem.</p>
          
          <div className="highlight-box">
            <h4><FontAwesomeIcon icon={faUser} /> Untuk Siapa Manual Ini</h4>
            <ul>
              <li>Guru yang menggunakan Website Rumah CERDAS dalam kegiatan pembelajaran</li>
              <li>Siswa yang mengakses dan mengerjakan aktivitas melalui Website Rumah CERDAS</li>
              <li>Pengguna baru yang membutuhkan panduan teknis penggunaan website</li>
            </ul>
            <p><em>Manual ini dapat digunakan tanpa memerlukan pengetahuan teknis khusus atau latar belakang teknologi informasi.</em></p>
          </div>

          <div className="highlight-box">
            <h4><FontAwesomeIcon icon={faBook} /> Cara Membaca Manual</h4>
            <ol>
              <li>Agar manual ini mudah digunakan, perhatikan ketentuan berikut</li>
              <li>Setiap langkah ditulis secara berurutan dan bernomor</li>
              <li>Ikuti langkah sesuai urutan untuk menghindari kesalahan penggunaan</li>
              <li>Nama menu, tombol, dan ikon ditulis sesuai dengan tampilan di website</li>
              <li>Gunakan gambar atau tangkapan layar (screenshot) sebagai panduan visual</li>
              <li>Satu langkah menunjukkan satu tindakan (klik, pilih, ketik, simpan)</li>
            </ol>
            <div className="example-box">
              <h5>Contoh penulisan langkah:</h5>
              <ul>
                <li>Klik menu Rancang</li>
                <li>Pilih tombol Buat Naskah Baru</li>
                <li>Ketik teks cerita</li>
                <li>Klik Simpan</li>
              </ul>
            </div>
          </div>

          <div className="warning-box">
            <h4><FontAwesomeIcon icon={faExclamationTriangle} /> Hal yang Tidak Dibahas dalam Manual Ini</h4>
            <p>Manual ini tidak membahas:</p>
            <ul>
              <li>Konsep atau prinsip pedagogik</li>
              <li>Teori pembelajaran, menulis, atau digital storytelling</li>
              <li>Sistem penilaian pembelajaran</li>
              <li>Refleksi proses belajar atau tujuan pembelajaran</li>
            </ul>
            <p><strong>Manual ini fokus pada petunjuk teknis penggunaan website.</strong></p>
            <p>Untuk pembahasan pedagogik dan implementasi pembelajaran, pengguna disarankan merujuk pada buku atau panduan pendamping Rumah CERDAS yang disediakan secara terpisah.</p>
          </div>
        </div>
      ),
      subsections: []
    },
    {
      id: 1,
      title: "🏁 BAGIAN 1: MEMULAI MENGGUNAKAN RUMAH CERDAS",
      icon: faHome,
      description: "Pengguna berhasil masuk ke sistem dan memahami tampilan awal tanpa kebingungan.",
      content: (
        <div className="manual-section-content">
          <h3>BAGIAN 1: MEMULAI MENGGUNAKAN RUMAH CERDAS</h3>
          <p className="section-focus"><strong>Fokus bab ini:</strong> pengguna berhasil masuk ke sistem dan memahami tampilan awal tanpa kebingungan.</p>
          
          <div className="subsection">
            <h4><FontAwesomeIcon icon={faWifi} /> 1.1 Membuka Website Rumah CERDAS</h4>
            <p>Ikuti langkah berikut, untuk mulai menggunakan Rumah CERDAS.</p>
            <ol>
              <li>Buka aplikasi browser di perangkat Anda (disarankan: Google Chrome atau Mozilla Firefox)</li>
              <li>Ketik alamat website: <strong>https://digitalstorycerdas.id</strong></li>
              <li>Tekan tombol Enter pada keyboard</li>
              <li>Tunggu hingga halaman utama Rumah CERDAS tampil sempurna</li>
            </ol>
            <div className="technical-note">
              <h5><FontAwesomeIcon icon={faExclamationTriangle} /> Catatan Teknis:</h5>
              <ul>
                <li>Pastikan perangkat terhubung dengan koneksi internet stabil</li>
                <li>Jika halaman tidak tampil sempurna, lakukan refresh halaman</li>
              </ul>
              <p><FontAwesomeIcon icon={faWifi} /> Ikon pendukung: 🌐 Website | 🔄 Refresh | 📶 Koneksi Internet</p>
            </div>
          </div>

          <div className="subsection">
            <h4><FontAwesomeIcon icon={faSignInAlt} /> 1.2 Login / Registrasi Akun</h4>
            
            <div className="subsubsection">
              <h5>A. Login Akun</h5>
              <p>Jika Anda sudah memiliki akun:</p>
              <ol>
                <li>Klik tombol Login di pojok kanan atas halaman</li>
                <li>Masukkan username/email</li>
                <li>Masukkan password</li>
                <li>Klik tombol Masuk</li>
              </ol>
              <p>Jika data benar, sistem akan mengarahkan Anda ke Beranda Rumah CERDAS.</p>
            </div>

            <div className="subsubsection">
              <h5>B. Registrasi Akun</h5>
              <p>Jika Anda belum memiliki akun:</p>
              <ol>
                <li>Klik tombol Daftar / Registrasi</li>
                <li>Isi data yang diminta pada formulir</li>
                <li>Pastikan data diisi dengan benar</li>
                <li>Klik Daftar</li>
                <li>Lakukan login menggunakan akun yang telah dibuat</li>
              </ol>
            </div>

            <div className="warning-box">
              <h5><FontAwesomeIcon icon={faQuestionCircle} /> ⚠️ Jika lupa password:</h5>
              <p>Gunakan fitur Lupa Password, lalu ikuti petunjuk yang ditampilkan di layar.</p>
              <p><FontAwesomeIcon icon={faLock} /> Ikon pendukung: 👤 Akun | 🔐 Login | ✍️ Registrasi | ❓ Lupa Password</p>
            </div>
          </div>

          <div className="subsection">
            <h4><FontAwesomeIcon icon={faHome} /> 1.3 Tampilan Awal dan Beranda 🏠</h4>
            <p>Setelah berhasil login, pengguna akan diarahkan ke Beranda Rumah CERDAS. Pada halaman Beranda, pengguna dapat melihat:</p>
            <ul>
              <li>Nama pengguna yang sedang aktif</li>
              <li>Menu utama Rumah CERDAS</li>
              <li>Akses cepat ke fitur pembelajaran</li>
              <li>Informasi progres atau aktivitas (jika tersedia)</li>
            </ul>
            <div className="function-box">
              <h5>Fungsi Beranda:</h5>
              <ul>
                <li>Sebagai titik awal navigasi</li>
                <li>Memberikan gambaran umum fitur yang tersedia</li>
                <li>Memudahkan pengguna berpindah ke ruang kerja digital</li>
              </ul>
              <p><FontAwesomeIcon icon={faHome} /> Ikon pendukung: 🏠 Beranda | 👀 Cermati | 🔍 Eksplorasi | 🧠 Rancang | 🎨 Desain | 🎯 Asah | 🌍 Sebar</p>
            </div>
          </div>

          <div className="subsection">
            <h4><FontAwesomeIcon icon={faChevronRight} /> 1.4 Navigasi Menu Utama 🧭</h4>
            <p>Menu utama Rumah CERDAS dirancang untuk memudahkan pengguna berpindah antar fitur.</p>
            
            <div className="subsubsection">
              <h5>A. Menu Sidebar (Sisi Kiri)</h5>
              <p>Menu ini berfungsi untuk:</p>
              <ul>
                <li>Berpindah halaman utama</li>
                <li>Mengakses panduan, tutorial, dan bahan belajar</li>
              </ul>
              <p>Contoh menu:</p>
              <ul>
                <li>Beranda</li>
                <li>Panduan</li>
                <li>Tutorial</li>
                <li>Bahan Belajar</li>
              </ul>
            </div>

            <div className="subsubsection">
              <h5>B. Menu Sintaks CERDAS (Bagian Atas)</h5>
              <p>Menu ini menampilkan tahapan kerja utama dalam Rumah CERDAS:</p>
              <ul>
                <li><FontAwesomeIcon icon={faEye} /> Cermati</li>
                <li><FontAwesomeIcon icon={faSearch} /> Eksplorasi</li>
                <li><FontAwesomeIcon icon={faBrain} /> Rancang</li>
                <li><FontAwesomeIcon icon={faPalette} /> Desain</li>
                <li><FontAwesomeIcon icon={faBullseye} /> Asah</li>
                <li><FontAwesomeIcon icon={faGlobe} /> Sebar</li>
              </ul>
              <p>Pengguna dapat mengklik setiap menu untuk masuk ke ruang kerja yang diinginkan.</p>
            </div>

            <div className="tips-box">
              <h5><FontAwesomeIcon icon={faQuestionCircle} /> Tips Navigasi:</h5>
              <ul>
                <li>Klik menu satu kali untuk masuk</li>
                <li>Gunakan tombol kembali pada browser jika diperlukan</li>
                <li>Pastikan perubahan data disimpan sebelum berpindah menu</li>
              </ul>
              <p><FontAwesomeIcon icon={faChevronRight} /> Ikon pendukung: 🧭 Navigasi | 📂 Menu | ⬅️ Kembali | 💾 Simpan</p>
            </div>
          </div>

          <div className="summary-box">
            <h4><FontAwesomeIcon icon={faBook} /> Ringkasan Bagian 1</h4>
            <p>Pada tahap ini, pengguna telah:</p>
            <ul>
              <li>✓ Membuka website Rumah CERDAS</li>
              <li>✓ Login atau membuat akun</li>
              <li>✓ Mengenali tampilan Beranda</li>
              <li>✓ Memahami navigasi menu utama</li>
            </ul>
            <p>Pengguna kini siap melanjutkan ke alur kerja Rumah CERDAS pada bab berikutnya.</p>
          </div>
        </div>
      ),
      subsections: ["1.1", "1.2", "1.3", "1.4"]
    },
    {
      id: 2,
      title: "🔄 BAGIAN 2: ALUR KERJA CERDAS DI WEBSITE",
      icon: faSync,
      description: "Memahami urutan penggunaan fitur dari awal sampai akhir",
      content: (
        <div className="manual-section-content">
          <h3>BAGIAN 2: ALUR KERJA CERDAS DI WEBSITE</h3>
          <p className="section-focus"><strong>Fokus bab ini:</strong> pengguna memahami urutan penggunaan fitur dari awal sampai akhir, serta cara berpindah antar ruang kerja di Website Rumah CERDAS.</p>
          
          <div className="subsection">
            <h4><FontAwesomeIcon icon={faChevronRight} /> 2.1 Alur Penggunaan dari Cermati sampai Sebar</h4>
            <p>Website Rumah CERDAS menggunakan alur kerja berurutan yang ditampilkan melalui menu CERDAS di bagian atas halaman. Urutan penggunaan adalah sebagai berikut:</p>
            <div className="flow-diagram">
              <div className="flow-step">
                <div className="flow-icon"><FontAwesomeIcon icon={faEye} /></div>
                <div className="flow-text">
                  <h5>Cermati</h5>
                  <p>Membuka dan membaca materi awal</p>
                </div>
              </div>
              <div className="flow-arrow">→</div>
              <div className="flow-step">
                <div className="flow-icon"><FontAwesomeIcon icon={faSearch} /></div>
                <div className="flow-text">
                  <h5>Eksplorasi</h5>
                  <p>Melihat contoh atau inspirasi</p>
                </div>
              </div>
              <div className="flow-arrow">→</div>
              <div className="flow-step">
                <div className="flow-icon"><FontAwesomeIcon icon={faBrain} /></div>
                <div className="flow-text">
                  <h5>Rancang</h5>
                  <p>Menulis dan menyusun naskah</p>
                </div>
              </div>
              <div className="flow-arrow">→</div>
              <div className="flow-step">
                <div className="flow-icon"><FontAwesomeIcon icon={faPalette} /></div>
                <div className="flow-text">
                  <h5>Desain</h5>
                  <p>Membuat storyboard dan cerita digital</p>
                </div>
              </div>
              <div className="flow-arrow">→</div>
              <div className="flow-step">
                <div className="flow-icon"><FontAwesomeIcon icon={faBullseye} /></div>
                <div className="flow-text">
                  <h5>Asah</h5>
                  <p>Mengedit dan memperbaiki hasil</p>
                </div>
              </div>
              <div className="flow-arrow">→</div>
              <div className="flow-step">
                <div className="flow-icon"><FontAwesomeIcon icon={faGlobe} /></div>
                <div className="flow-text">
                  <h5>Sebar</h5>
                  <p>Menampilkan atau membagikan karya</p>
                </div>
              </div>
            </div>
            
            <div className="technical-note">
              <h5><FontAwesomeIcon icon={faExclamationTriangle} /> Catatan Penting:</h5>
              <ul>
                <li>Pengguna tidak wajib menyelesaikan semua tahap dalam satu waktu</li>
                <li>Data yang sudah disimpan dapat dilanjutkan kembali di waktu lain</li>
                <li>Urutan ini membantu pengguna bekerja secara terstruktur</li>
              </ul>
              <p><FontAwesomeIcon icon={faChevronRight} /> Ikon pendukung: 👀 Cermati | 🔍 Eksplorasi | 🧠 Rancang | 🎨 Desain | 🎯 Asah | 🌍 Sebar</p>
            </div>
          </div>

          <div className="subsection">
            <h4><FontAwesomeIcon icon={faChevronRight} /> 2.2 Ikon, Tombol, dan Navigasi Umum</h4>
            <p>Beberapa ikon dan tombol umum digunakan di hampir semua ruang kerja Rumah CERDAS.</p>
            
            <div className="icons-grid">
              <div className="icon-item">
                <div className="icon-box"><FontAwesomeIcon icon={faHome} /></div>
                <div className="icon-desc">
                  <strong>🏠 Beranda</strong>
                  <p>Kembali ke halaman utama</p>
                </div>
              </div>
              <div className="icon-item">
                <div className="icon-box"><FontAwesomeIcon icon={faSave} /></div>
                <div className="icon-desc">
                  <strong>💾 Simpan</strong>
                  <p>Menyimpan pekerjaan</p>
                </div>
              </div>
              <div className="icon-item">
                <div className="icon-box"><FontAwesomeIcon icon={faPlus} /></div>
                <div className="icon-desc">
                  <strong>➕ Tambah</strong>
                  <p>Menambahkan naskah atau scene</p>
                </div>
              </div>
              <div className="icon-item">
                <div className="icon-box"><FontAwesomeIcon icon={faPlay} /></div>
                <div className="icon-desc">
                  <strong>▶️ Preview</strong>
                  <p>Melihat hasil sementara</p>
                </div>
              </div>
              <div className="icon-item">
                <div className="icon-box"><FontAwesomeIcon icon={faArrowLeft} /></div>
                <div className="icon-desc">
                  <strong>⬅️ Kembali</strong>
                  <p>Kembali ke halaman sebelumnya</p>
                </div>
              </div>
              <div className="icon-item">
                <div className="icon-box"><FontAwesomeIcon icon={faUser} /></div>
                <div className="icon-desc">
                  <strong>👤 Profil</strong>
                  <p>Melihat atau mengatur akun</p>
                </div>
              </div>
            </div>

            <div className="tips-box">
              <h5><FontAwesomeIcon icon={faQuestionCircle} /> Tips Penggunaan:</h5>
              <ul>
                <li>Klik tombol Simpan secara berkala</li>
                <li>Pastikan pekerjaan tersimpan sebelum berpindah menu</li>
                <li>Gunakan Preview untuk memastikan hasil sesuai</li>
              </ul>
            </div>
          </div>

          <div className="subsection">
            <h4><FontAwesomeIcon icon={faChevronRight} /> 2.3 Cara Berpindah Antar Ruang</h4>
            <p>Pengguna dapat berpindah antar ruang kerja dengan beberapa cara berikut:</p>
            
            <div className="subsubsection">
              <h5>A. Melalui Menu CERDAS</h5>
              <p>Klik salah satu menu Cermati hingga Sebar di bagian atas halaman, maka sistem akan langsung membuka ruang yang dipilih</p>
            </div>

            <div className="subsubsection">
              <h5>B. Melalui Menu Beranda</h5>
              <ol>
                <li>Klik Beranda</li>
                <li>Pilih ruang kerja yang ingin diakses</li>
              </ol>
            </div>

            <div className="subsubsection">
              <h5>C. Menggunakan Navigasi Browser</h5>
              <ul>
                <li>Gunakan tombol Kembali (Back) pada browser jika diperlukan</li>
                <li>Pastikan pekerjaan sudah disimpan sebelum menggunakan tombol ini</li>
              </ul>
            </div>

            <div className="warning-box">
              <h5><FontAwesomeIcon icon={faExclamationTriangle} /> ⚠️ Perhatian:</h5>
              <ul>
                <li>Berpindah ruang tanpa menyimpan dapat menyebabkan data tidak tersimpan</li>
                <li>Selalu periksa notifikasi simpan sebelum berpindah halaman</li>
              </ul>
              <p><FontAwesomeIcon icon={faBell} /> Ikon pendukung: 🧭 Navigasi | ⬅️ Back | 💾 Simpan | 🔔 Notifikasi</p>
            </div>
          </div>

          <div className="summary-box">
            <h4><FontAwesomeIcon icon={faBook} /> Ringkasan Bagian 2</h4>
            <p>Pada tahap ini, pengguna telah:</p>
            <ul>
              <li>✓ Memahami alur kerja CERDAS di website</li>
              <li>✓ Mengenali ikon dan tombol utama</li>
              <li>✓ Mengetahui cara berpindah antar ruang kerja</li>
            </ul>
            <p>Pengguna kini siap menggunakan fitur secara bertahap pada bab berikutnya.</p>
          </div>
        </div>
      ),
      subsections: ["2.1", "2.2", "2.3"]
    },
    {
      id: 3,
      title: "👀 BAGIAN 3: MENGGUNAKAN RUANG CERMATI & EKSPLORASI",
      icon: faEye,
      description: "Membuka, membaca, dan melihat konten pada Ruang Cermati dan Eksplorasi",
      content: (
        <div className="manual-section-content">
          <h3>BAGIAN 3: MENGGUNAKAN RUANG CERMATI & EKSPLORASI</h3>
          <p className="section-focus"><strong>Fokus bab ini:</strong> pengguna dapat membuka, membaca, dan melihat konten pada Ruang Cermati dan Eksplorasi tanpa kebingungan.</p>
          
          <div className="subsection">
            <h4><FontAwesomeIcon icon={faEye} /> 3.1 Membuka Ruang Cermati</h4>
            <p>Ikuti langkah berikut, untuk membuka Ruang Cermati.</p>
            <ol>
              <li>Pastikan Anda sudah login ke Website Rumah CERDAS</li>
              <li>Pada menu bagian atas, klik <strong>Cermati</strong></li>
              <li>Sistem akan menampilkan halaman Ruang Cermati</li>
              <li>Tunggu hingga daftar materi tampil sempurna</li>
            </ol>
            <div className="technical-note">
              <h5><FontAwesomeIcon icon={faExclamationTriangle} /> Catatan:</h5>
              <ul>
                <li>Ruang Cermati digunakan untuk membaca atau melihat materi awal</li>
                <li>Tidak ada tombol untuk menulis atau mengedit di ruang ini</li>
              </ul>
              <p><FontAwesomeIcon icon={faEye} /> Ikon pendukung: 👀 Cermati | 📄 Materi | 🏠 Beranda</p>
            </div>
          </div>

          <div className="subsection">
            <h4><FontAwesomeIcon icon={faBook} /> 3.2 Mengakses Materi di Ruang Cermati</h4>
            <p>Setelah berada di Ruang Cermati:</p>
            <ol>
              <li>Pilih judul materi yang tersedia</li>
              <li>Klik judul materi untuk membuka isi</li>
              <li>Gunakan scroll mouse atau layar untuk membaca konten</li>
              <li>Klik tombol Kembali untuk kembali ke daftar materi</li>
            </ol>
            <div className="tips-box">
              <h5><FontAwesomeIcon icon={faQuestionCircle} /> Tips Teknis:</h5>
              <ul>
                <li>Pastikan halaman selesai dimuat sebelum berpindah materi</li>
                <li>Gunakan ukuran layar yang cukup agar teks terbaca jelas</li>
              </ul>
              <p><FontAwesomeIcon icon={faBook} /> Ikon pendukung: 📘 Materi | ⬅️ Kembali | 🔄 Refresh</p>
            </div>
          </div>

          <div className="subsection">
            <h4><FontAwesomeIcon icon={faSearch} /> 3.3 Membuka Ruang Eksplorasi</h4>
            <p>Untuk membuka Ruang Eksplorasi:</p>
            <ol>
              <li>Klik menu <strong>Eksplorasi</strong> pada bagian atas halaman</li>
              <li>Sistem akan menampilkan halaman Ruang Eksplorasi</li>
              <li>Tunggu hingga daftar contoh atau media tampil</li>
            </ol>
            <div className="technical-note">
              <h5><FontAwesomeIcon icon={faExclamationTriangle} /> Catatan:</h5>
              <ul>
                <li>Ruang Eksplorasi berisi contoh atau inspirasi</li>
                <li>Pengguna tidak dapat mengedit konten di ruang ini</li>
              </ul>
              <p><FontAwesomeIcon icon={faSearch} /> Ikon pendukung: 🔍 Eksplorasi | 🖼️ Media | ▶️ Video</p>
            </div>
          </div>

          <div className="subsection">
            <h4><FontAwesomeIcon icon={faPlay} /> 3.4 Menonton atau Melihat Contoh</h4>
            <p>Untuk melihat contoh di Ruang Eksplorasi:</p>
            <ol>
              <li>Klik thumbnail atau judul contoh yang tersedia</li>
              <li>Klik tombol Play</li>
              <li>Atur volume atau ukuran layar jika diperlukan</li>
              <li>Setelah selesai, klik Kembali untuk melihat contoh lain</li>
            </ol>
            <div className="tips-box">
              <h5><FontAwesomeIcon icon={faQuestionCircle} /> Tips Teknis:</h5>
              <ul>
                <li>Gunakan koneksi internet stabil saat menonton video</li>
                <li>Tutup tab lain jika video tidak berjalan lancar</li>
              </ul>
              <p><FontAwesomeIcon icon={faPlay} /> Ikon pendukung: ▶️ Play | 🔊 Volume | ⬅️ Kembali | ⏸️ Pause</p>
            </div>
          </div>

          <div className="summary-box">
            <h4><FontAwesomeIcon icon={faBook} /> Ringkasan Bagian 3</h4>
            <p>Pada tahap ini, pengguna telah:</p>
            <ul>
              <li>✓ Membuka Ruang Cermati</li>
              <li>✓ Mengakses dan membaca materi</li>
              <li>✓ Membuka Ruang Eksplorasi</li>
              <li>✓ Menonton atau melihat contoh yang tersedia</li>
            </ul>
            <p>Setelah selesai menggunakan Ruang Cermati dan Eksplorasi, pengguna dapat melanjutkan ke Ruang Rancang untuk mulai menulis.</p>
          </div>
        </div>
      ),
      subsections: ["3.1", "3.2", "3.3", "3.4"]
    },
    {
      id: 4,
      title: "✍️ BAGIAN 4: MENULIS DI RUANG RANCANG",
      icon: faPencilAlt,
      description: "Membuat naskah, menulis, mengedit, menyimpan, dan memantau progres",
      content: (
        <div className="manual-section-content">
          <h3>BAGIAN 4: MENULIS DI RUANG RANCANG</h3>
          <p className="section-focus"><strong>Fokus bab ini:</strong> pengguna dapat membuka Ruang Rancang, membuat naskah, menulis, mengedit, menyimpan, dan memantau progres pekerjaan dengan lancar.</p>
          
          <div className="subsection">
            <h4><FontAwesomeIcon icon={faBrain} /> 4.1 Membuka Ruang Rancang</h4>
            <p>Lakukan langkah berikut, untuk mulai menulis!</p>
            <ol>
              <li>Pastikan Anda sudah login ke Website Rumah CERDAS</li>
              <li>Pada menu bagian atas, klik <strong>Rancang</strong></li>
              <li>Sistem akan menampilkan halaman Dunia Menulis Kreatif</li>
              <li>Pastikan halaman termuat sempurna sebelum melanjutkan</li>
            </ol>
            <div className="technical-note">
              <h5><FontAwesomeIcon icon={faExclamationTriangle} /> Catatan:</h5>
              <ul>
                <li>Ruang Rancang digunakan khusus untuk menulis dan menyusun naskah</li>
                <li>Proses menulis dilakukan langsung di dalam sistem</li>
              </ul>
              <p><FontAwesomeIcon icon={faBrain} /> Ikon pendukung: 🧠 Rancang | 🏠 Beranda | 📄 Naskah</p>
            </div>
          </div>

          <div className="subsection">
            <h4><FontAwesomeIcon icon={faPlus} /> 4.2 Membuat Naskah Baru</h4>
            <p>Untuk membuat naskah baru:</p>
            <ol>
              <li>Di halaman Ruang Rancang, klik tombol <strong>Menulis Naskah</strong> atau <strong>Buat Naskah Baru</strong></li>
              <li>Sistem akan membuka halaman editor naskah</li>
              <li>Jika diminta, isi judul naskah</li>
              <li>Pastikan kolom penulisan aktif dan siap digunakan</li>
            </ol>
            <div className="tips-box">
              <h5><FontAwesomeIcon icon={faQuestionCircle} /> Tips Teknis:</h5>
              <ul>
                <li>Gunakan judul singkat agar mudah dikenali</li>
                <li>Satu naskah dibuat untuk satu cerita</li>
              </ul>
              <p><FontAwesomeIcon icon={faPencilAlt} /> Ikon pendukung: ✍️ Menulis | ➕ Buat Baru | 📝 Editor</p>
            </div>
          </div>

          <div className="subsection">
            <h4><FontAwesomeIcon icon={faPencilAlt} /> 4.3 Menulis dan Mengedit Teks</h4>
            <p>Untuk menulis dan mengedit teks naskah:</p>
            <ol>
              <li>Ketik teks cerita pada kolom editor</li>
              <li>Gunakan keyboard untuk menambah, menghapus, atau memperbaiki teks</li>
              <li>Jika tersedia, gunakan toolbar editor (tebal, miring, paragraf)</li>
              <li>Lakukan pengeditan langsung pada teks yang sudah ditulis</li>
            </ol>
            <div className="technical-note">
              <h5><FontAwesomeIcon icon={faExclamationTriangle} /> Catatan Teknis:</h5>
              <ul>
                <li>Editor bekerja seperti editor teks pada umumnya</li>
                <li>Perubahan teks belum tersimpan otomatis sebelum disimpan</li>
              </ul>
              <p><FontAwesomeIcon icon={faPencilAlt} /> Ikon pendukung: 📝 Editor | ⌨️ Ketik | ✏️ Edit</p>
            </div>
          </div>

          <div className="subsection">
            <h4><FontAwesomeIcon icon={faSave} /> 4.4 Menyimpan dan Melanjutkan Naskah</h4>
            <p>Untuk menyimpan pekerjaan:</p>
            <ol>
              <li>Klik tombol <strong>Simpan</strong> setelah menulis atau mengedit</li>
              <li>Tunggu notifikasi bahwa naskah berhasil disimpan</li>
              <li>Anda dapat keluar dari Ruang Rancang setelah proses simpan selesai</li>
              <li>Untuk melanjutkan, buka kembali Ruang Rancang dan pilih naskah yang telah dibuat</li>
            </ol>
            <div className="warning-box">
              <h5><FontAwesomeIcon icon={faExclamationTriangle} /> ⚠️ Peringatan Penting:</h5>
              <ul>
                <li>Jangan berpindah menu sebelum menekan Simpan</li>
                <li>Pastikan muncul notifikasi simpan berhasil</li>
              </ul>
              <p><FontAwesomeIcon icon={faSave} /> Ikon pendukung: 💾 Simpan | 🔔 Notifikasi | ⏳ Proses</p>
            </div>
          </div>

          <div className="subsection">
            <h4><FontAwesomeIcon icon={faChevronRight} /> 4.5 Melihat Progres Penulisan</h4>
            <p>Untuk melihat progres pekerjaan:</p>
            <ul>
              <li>Perhatikan indikator progres yang tampil di Ruang Rancang</li>
              <li>Progres ditampilkan dalam bentuk persentase atau ikon tahap</li>
              <li>Gunakan indikator ini untuk mengetahui status pekerjaan</li>
            </ul>
            <div className="technical-note">
              <h5><FontAwesomeIcon icon={faExclamationTriangle} /> Catatan:</h5>
              <ul>
                <li>Progres membantu memantau sejauh mana naskah telah dikerjakan</li>
                <li>Progres tidak memengaruhi fungsi simpan atau edit</li>
              </ul>
              <p><FontAwesomeIcon icon={faChevronRight} /> Ikon pendukung: 📊 Progres | ✔️ Selesai | 🔄 Proses</p>
            </div>
          </div>

          <div className="summary-box">
            <h4><FontAwesomeIcon icon={faBook} /> Ringkasan Bagian 4</h4>
            <p>Pada tahap ini, pengguna telah:</p>
            <ul>
              <li>✓ Membuka Ruang Rancang</li>
              <li>✓ Membuat naskah baru</li>
              <li>✓ Menulis dan mengedit teks</li>
              <li>✓ Menyimpan dan melanjutkan pekerjaan</li>
              <li>✓ Melihat progres penulisan</li>
            </ul>
            <p>Setelah naskah selesai ditulis, pengguna dapat melanjutkan ke Ruang Desain untuk membuat cerita digital.</p>
          </div>
        </div>
      ),
      subsections: ["4.1", "4.2", "4.3", "4.4", "4.5"]
    },
    {
      id: 5,
      title: "🎨 BAGIAN 5: MEMBUAT CERITA DIGITAL DI RUANG DESAIN",
      icon: faPalette,
      description: "Membuat storyboard, mengatur scene, pratinjau, dan menyimpan hasil",
      content: (
        <div className="manual-section-content">
          <h3>BAGIAN 5: MEMBUAT CERITA DIGITAL DI RUANG DESAIN</h3>
          <p className="section-focus"><strong>Fokus bab ini:</strong> pengguna dapat membuka Ruang Desain, membuat storyboard, mengatur scene, melakukan pratinjau, dan menyimpan hasil secara teknis.</p>
          
          <div className="subsection">
            <h4><FontAwesomeIcon icon={faPalette} /> 5.1 Membuka Ruang Desain</h4>
            <p>Ikuti langkah berikut, Untuk masuk ke Ruang Desain!</p>
            <ol>
              <li>Pastikan Anda sudah login ke Website Rumah CERDAS</li>
              <li>Pada menu bagian atas, klik <strong>Desain</strong></li>
              <li>Sistem akan menampilkan halaman Studio Storyboard Kreatif</li>
              <li>Tunggu hingga seluruh elemen halaman termuat sempurna</li>
            </ol>
            <div className="technical-note">
              <h5><FontAwesomeIcon icon={faExclamationTriangle} /> Catatan Teknis:</h5>
              <ul>
                <li>Ruang Desain digunakan untuk mengolah naskah menjadi cerita digital</li>
                <li>Pastikan naskah sudah tersedia sebelum menggunakan ruang ini</li>
              </ul>
              <p><FontAwesomeIcon icon={faPalette} /> Ikon pendukung: 🎨 Desain | 🏠 Beranda | 🗂️ Proyek</p>
            </div>
          </div>

          <div className="subsection">
            <h4><FontAwesomeIcon icon={faPlus} /> 5.2 Membuat Storyboard</h4>
            <p>Untuk membuat storyboard baru:</p>
            <ol>
              <li>Di halaman Ruang Desain, klik tombol <strong>Storyboard Baru</strong> atau <strong>Project Baru</strong></li>
              <li>Sistem akan membuat proyek storyboard kosong</li>
              <li>Pastikan nama proyek atau judul tampil di layar</li>
              <li>Editor storyboard akan terbuka secara otomatis</li>
            </ol>
            <div className="tips-box">
              <h5><FontAwesomeIcon icon={faQuestionCircle} /> Tips Teknis:</h5>
              <ul>
                <li>Satu storyboard digunakan untuk satu cerita</li>
                <li>Perubahan storyboard perlu disimpan secara berkala</li>
              </ul>
              <p><FontAwesomeIcon icon={faPlus} /> Ikon pendukung: 🧩 Storyboard | ➕ Project Baru | 📝 Editor</p>
            </div>
          </div>

          <div className="subsection">
            <h4><FontAwesomeIcon icon={faChevronRight} /> 5.3 Menambah dan Mengatur Scene</h4>
            <p>Untuk menambahkan dan mengatur scene:</p>
            <ol>
              <li>Klik tombol <strong>Tambah Scene</strong></li>
              <li>Scene baru akan muncul pada daftar scene</li>
              <li>Pilih scene untuk mengedit isinya</li>
              <li>Atur urutan scene pada fitur pengurutan</li>
              <li>Ulangi langkah untuk menambah scene berikutnya</li>
            </ol>
            <div className="technical-note">
              <h5><FontAwesomeIcon icon={faExclamationTriangle} /> Catatan Teknis:</h5>
              <ul>
                <li>Setiap scene mewakili satu bagian cerita</li>
                <li>Scene dapat ditambah sesuai kebutuhan cerita</li>
              </ul>
              <p><FontAwesomeIcon icon={faChevronRight} /> Ikon pendukung: 🎞️ Scene | ➕ Tambah | ↕️ Urutan</p>
            </div>
          </div>

          <div className="subsection">
            <h4><FontAwesomeIcon icon={faPlay} /> 5.4 Preview Cerita</h4>
            <p>Untuk melihat hasil sementara cerita digital:</p>
            <ol>
              <li>Klik tombol <strong>Preview</strong> atau <strong>Preview Storyboard</strong></li>
              <li>Sistem akan menampilkan pratinjau cerita</li>
              <li>Perhatikan urutan scene dan durasi tampilan</li>
              <li>Tutup tampilan preview untuk kembali ke editor</li>
            </ol>
            <div className="tips-box">
              <h5><FontAwesomeIcon icon={faQuestionCircle} /> Tips Teknis:</h5>
              <ul>
                <li>Gunakan preview untuk memastikan urutan scene sudah benar</li>
                <li>Preview tidak mengubah isi storyboard</li>
              </ul>
              <p><FontAwesomeIcon icon={faPlay} /> Ikon pendukung: ▶️ Preview | ⏸️ Pause | ⬅️ Kembali</p>
            </div>
          </div>

          <div className="subsection">
            <h4><FontAwesomeIcon icon={faSave} /> 5.5 Menyimpan Hasil Storyboard</h4>
            <p>Untuk menyimpan hasil pekerjaan:</p>
            <ol>
              <li>Klik tombol <strong>Simpan Project</strong></li>
              <li>Tunggu hingga notifikasi simpan berhasil muncul</li>
              <li>Pastikan status proyek tersimpan sebelum keluar dari Ruang Desain</li>
              <li>Anda dapat melanjutkan pekerjaan di waktu lain</li>
            </ol>
            <div className="warning-box">
              <h5><FontAwesomeIcon icon={faExclamationTriangle} /> ⚠️ Peringatan Penting:</h5>
              <ul>
                <li>Jangan menutup halaman sebelum proses simpan selesai</li>
                <li>Pastikan koneksi internet stabil saat menyimpan</li>
              </ul>
              <p><FontAwesomeIcon icon={faSave} /> Ikon pendukung: 💾 Simpan | 🔔 Notifikasi | ⏳ Proses</p>
            </div>
          </div>

          <div className="summary-box">
            <h4><FontAwesomeIcon icon={faBook} /> Ringkasan Bagian 5</h4>
            <p>Pada tahap ini, pengguna telah:</p>
            <ul>
              <li>✓ Membuka Ruang Desain</li>
              <li>✓ Membuat storyboard baru</li>
              <li>✓ Menambah dan mengatur scene</li>
              <li>✓ Melakukan preview cerita</li>
              <li>✓ Menyimpan hasil storyboard</li>
            </ul>
            <p>Setelah storyboard selesai, pengguna dapat melanjutkan ke Ruang Asah untuk melakukan perbaikan akhir.</p>
          </div>
        </div>
      ),
      subsections: ["5.1", "5.2", "5.3", "5.4", "5.5"]
    },
    {
      id: 6,
      title: "🎯 BAGIAN 6: MENGEDIT, MENYIMPAN, DAN MEMBAGIKAN",
      icon: faBullseye,
      description: "Perbaikan akhir, menyimpan revisi, dan menampilkan karya",
      content: (
        <div className="manual-section-content">
          <h3>BAGIAN 6: MENGEDIT, MENYIMPAN, DAN MEMBAGIKAN</h3>
          <p className="section-focus"><strong>Fokus bab ini:</strong> pengguna dapat melakukan perbaikan akhir, menyimpan hasil revisi, dan menampilkan atau membagikan karya dengan aman.</p>
          
          <div className="subsection">
            <h4><FontAwesomeIcon icon={faBullseye} /> 6.1 Menggunakan Ruang Asah</h4>
            <p>Ruang Asah digunakan untuk melakukan perbaikan akhir sebelum karya ditampilkan atau dibagikan. Untuk membuka Ruang Asah:</p>
            <ol>
              <li>Pastikan Anda sudah login ke Website Rumah CERDAS</li>
              <li>Pada menu bagian atas, klik <strong>Asah</strong></li>
              <li>Sistem akan menampilkan halaman Ruang Asah</li>
              <li>Pilih karya atau proyek yang akan diperbaiki</li>
            </ol>
            <div className="technical-note">
              <h5><FontAwesomeIcon icon={faExclamationTriangle} /> Catatan Teknis:</h5>
              <ul>
                <li>Ruang Asah digunakan untuk edit akhir, bukan pembuatan awal</li>
                <li>Pastikan proyek yang dipilih adalah versi terbaru</li>
              </ul>
              <p><FontAwesomeIcon icon={faBullseye} /> Ikon pendukung: 🎯 Asah | 🗂️ Proyek | ✏️ Edit</p>
            </div>
          </div>

          <div className="subsection">
            <h4><FontAwesomeIcon icon={faSave} /> 6.2 Menyimpan Revisi</h4>
            <p>Setelah melakukan perbaikan pada karya:</p>
            <ol>
              <li>Klik tombol <strong>Simpan</strong> atau <strong>Simpan Revisi</strong></li>
              <li>Tunggu hingga muncul notifikasi bahwa revisi berhasil disimpan</li>
              <li>Pastikan tidak ada perubahan tertunda sebelum keluar dari halaman</li>
              <li>Jika perlu, ulangi proses edit dan simpan</li>
            </ol>
            <div className="warning-box">
              <h5><FontAwesomeIcon icon={faExclamationTriangle} /> ⚠️ Peringatan Penting:</h5>
              <ul>
                <li>Jangan berpindah menu sebelum proses simpan selesai</li>
                <li>Pastikan koneksi internet stabil saat menyimpan revisi</li>
              </ul>
              <p><FontAwesomeIcon icon={faSave} /> Ikon pendukung: 💾 Simpan | 🔔 Notifikasi | ⏳ Proses</p>
            </div>
          </div>

          <div className="subsection">
            <h4><FontAwesomeIcon icon={faGlobe} /> 6.3 Menggunakan Ruang Sebar</h4>
            <p>Ruang Sebar digunakan untuk menampilkan atau membagikan karya yang telah selesai. Untuk membuka Ruang Sebar:</p>
            <ol>
              <li>Klik menu <strong>Sebar</strong> pada bagian atas halaman</li>
              <li>Sistem akan menampilkan daftar karya yang siap ditampilkan</li>
              <li>Pilih karya yang akan dibagikan atau ditampilkan</li>
            </ol>
            <div className="technical-note">
              <h5><FontAwesomeIcon icon={faExclamationTriangle} /> Catatan Teknis:</h5>
              <ul>
                <li>Hanya karya yang sudah disimpan dengan benar yang dapat ditampilkan</li>
                <li>Pastikan karya sudah melalui tahap Asah sebelum dibagikan</li>
              </ul>
              <p><FontAwesomeIcon icon={faGlobe} /> Ikon pendukung: 🌍 Sebar | 📂 Karya | 👁️ Tampil</p>
            </div>
          </div>

          <div className="subsection">
            <h4><FontAwesomeIcon icon={faUpload} /> 6.4 Menampilkan atau Mengunggah Karya</h4>
            <p>Untuk menampilkan atau mengunggah karya:</p>
            <ol>
              <li>Pilih karya di Ruang Sebar</li>
              <li>Klik tombol <strong>Tampilkan</strong>, <strong>Bagikan</strong>, atau <strong>Unggah</strong> (sesuai fitur yang tersedia)</li>
              <li>Tunggu hingga proses selesai</li>
              <li>Pastikan karya berhasil ditampilkan atau dapat diakses sesuai pengaturan</li>
            </ol>
            <div className="tips-box">
              <h5><FontAwesomeIcon icon={faQuestionCircle} /> Tips Teknis:</h5>
              <ul>
                <li>Periksa kembali karya sebelum dibagikan</li>
                <li>Jangan menutup halaman selama proses unggah berlangsung</li>
              </ul>
              <p><FontAwesomeIcon icon={faUpload} /> Ikon pendukung: 📤 Unggah | 👁️ Tampilkan | ✔️ Berhasil</p>
            </div>
          </div>

          <div className="summary-box">
            <h4><FontAwesomeIcon icon={faBook} /> Ringkasan Bagian 6</h4>
            <p>Pada tahap ini, pengguna telah:</p>
            <ul>
              <li>✓ Menggunakan Ruang Asah untuk perbaikan akhir</li>
              <li>✓ Menyimpan revisi karya</li>
              <li>✓ Menggunakan Ruang Sebar</li>
              <li>✓ Menampilkan atau mengunggah karya</li>
            </ul>
            <p>Dengan selesainya tahap ini, alur penggunaan Website Rumah CERDAS telah lengkap.</p>
          </div>
        </div>
      ),
      subsections: ["6.1", "6.2", "6.3", "6.4"]
    },
    {
      id: 7,
      title: "🆘 BAGIAN 7: BANTUAN DAN PEMECAHAN MASALAH",
      icon: faQuestionCircle,
      description: "Mengatasi kendala teknis umum secara cepat",
      content: (
        <div className="manual-section-content">
          <h3>BAGIAN 7: BANTUAN DAN PEMECAHAN MASALAH</h3>
          <p className="section-focus"><strong>Fokus bab ini:</strong> membantu pengguna mengatasi kendala teknis umum secara cepat tanpa memerlukan bantuan teknis lanjutan.</p>
          
          <div className="subsection">
            <h4><FontAwesomeIcon icon={faSignInAlt} /> 7.1 Tidak Bisa Login</h4>
            <p>Jika pengguna tidak dapat login ke Website Rumah CERDAS, lakukan langkah berikut:</p>
            <ul>
              <li>Pastikan username/email dan password diketik dengan benar</li>
              <li>Perhatikan huruf besar dan kecil (case sensitive)</li>
              <li>Pastikan koneksi internet aktif</li>
            </ul>
            
            <div className="solution-box">
              <h5><FontAwesomeIcon icon={faQuestionCircle} /> Solusi cepat:</h5>
              <ol>
                <li>Klik menu <strong>Lupa Password</strong></li>
                <li>Ikuti petunjuk reset yang ditampilkan</li>
                <li>Login kembali menggunakan password baru</li>
              </ol>
            </div>

            <div className="technical-note">
              <h5><FontAwesomeIcon icon={faExclamationTriangle} /> Jika masalah berlanjut:</h5>
              <ul>
                <li>Coba login menggunakan browser lain</li>
                <li>Tutup dan buka kembali browser</li>
              </ul>
              <p><FontAwesomeIcon icon={faSignInAlt} /> Ikon pendukung: 🔐 Login | ❓ Lupa Password | 🌐 Internet</p>
            </div>
          </div>

          <div className="subsection">
            <h4><FontAwesomeIcon icon={faSave} /> 7.2 Data Tidak Tersimpan</h4>
            <p>Jika naskah atau storyboard tidak tersimpan, maka periksa hal berikut:</p>
            <ul>
              <li>Apakah tombol Simpan sudah diklik</li>
              <li>Apakah notifikasi simpan berhasil muncul</li>
              <li>Apakah koneksi internet stabil</li>
            </ul>
            
            <div className="solution-box">
              <h5><FontAwesomeIcon icon={faQuestionCircle} /> Solusi cepat:</h5>
              <ol>
                <li>Klik tombol Simpan sekali lagi</li>
                <li>Tunggu notifikasi simpan</li>
                <li>Jangan berpindah menu sebelum proses selesai</li>
              </ol>
            </div>

            <div className="warning-box">
              <h5><FontAwesomeIcon icon={faExclamationTriangle} /> ⚠️ Penting:</h5>
              <ul>
                <li>Jangan menutup halaman saat proses simpan berlangsung</li>
                <li>Simpan pekerjaan secara berkala</li>
              </ul>
              <p><FontAwesomeIcon icon={faSave} /> Ikon pendukung: 💾 Simpan | 🔔 Notifikasi | ⏳ Proses</p>
            </div>
          </div>

          <div className="subsection">
            <h4><FontAwesomeIcon icon={faSync} /> 7.3 Tampilan Tidak Sesuai</h4>
            <p>Jika tampilan halaman tidak sempurna atau tidak sesuai, solusi cepat:</p>
            <ol>
              <li>Klik tombol <strong>Refresh / Muat Ulang</strong> halaman</li>
              <li>Periksa koneksi internet</li>
              <li>Perbesar atau perkecil tampilan layar (zoom)</li>
              <li>Gunakan browser yang disarankan (Chrome/Firefox)</li>
            </ol>
            
            <div className="technical-note">
              <h5><FontAwesomeIcon icon={faExclamationTriangle} /> Jika masih bermasalah:</h5>
              <ul>
                <li>Tutup tab lain yang tidak digunakan</li>
                <li>Coba akses dari perangkat lain</li>
              </ul>
              <p><FontAwesomeIcon icon={faSync} /> Ikon pendukung: 🔄 Refresh | 🖥️ Layar | 🌐 Browser</p>
            </div>
          </div>

          <div className="subsection">
            <h4><FontAwesomeIcon icon={faShieldAlt} /> 7.4 Tips Penggunaan Aman</h4>
            <p>Perhatikan tips berikut, untuk penggunaan Website Rumah CERDAS yang aman dan lancar.</p>
            <ul>
              <li>Selalu klik Simpan sebelum berpindah menu</li>
              <li>Jangan membagikan username dan password kepada orang lain</li>
              <li>Logout setelah selesai menggunakan website</li>
              <li>Gunakan koneksi internet yang stabil</li>
              <li>Hindari membuka banyak tab saat menggunakan website</li>
            </ul>
            <p><FontAwesomeIcon icon={faShieldAlt} /> Ikon pendukung: 🛡️ Aman | 🔒 Logout | 📶 Stabil</p>
          </div>

          <div className="closing-box">
            <h4><FontAwesomeIcon icon={faBook} /> Penutup:</h4>
            <p>Manual ini disusun untuk membantu pengguna mengoperasikan Website Rumah CERDAS secara teknis dari awal hingga akhir.</p>
            <p>Jika kendala belum teratasi, silakan hubungi tim pengembang Rumah CERDAS melalui kontak resmi yang tersedia.</p>
          </div>
        </div>
      ),
      subsections: ["7.1", "7.2", "7.3", "7.4"]
    },
    {
      id: 8,
      title: "📋 LAMPIRAN",
      icon: faDownload,
      description: "Daftar ikon, tips cepat, dan kontak bantuan",
      content: (
        <div className="manual-section-content">
          <h3>LAMPIRAN</h3>
          
          <div className="subsection">
            <h4><FontAwesomeIcon icon={faChevronRight} /> A. Daftar Ikon dan Fungsinya</h4>
            <div className="table-responsive">
              <table className="icons-table">
                <thead>
                  <tr>
                    <th>Ikon</th>
                    <th>Nama Ikon</th>
                    <th>Fungsi</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><FontAwesomeIcon icon={faHome} /></td>
                    <td>Beranda</td>
                    <td>Kembali ke halaman utama</td>
                  </tr>
                  <tr>
                    <td><FontAwesomeIcon icon={faEye} /></td>
                    <td>Cermati</td>
                    <td>Membuka ruang materi awal</td>
                  </tr>
                  <tr>
                    <td><FontAwesomeIcon icon={faSearch} /></td>
                    <td>Eksplorasi</td>
                    <td>Membuka ruang contoh dan inspirasi</td>
                  </tr>
                  <tr>
                    <td><FontAwesomeIcon icon={faBrain} /></td>
                    <td>Rancang</td>
                    <td>Membuka ruang penulisan naskah</td>
                  </tr>
                  <tr>
                    <td><FontAwesomeIcon icon={faPalette} /></td>
                    <td>Desain</td>
                    <td>Membuka ruang storyboard dan cerita digital</td>
                  </tr>
                  <tr>
                    <td><FontAwesomeIcon icon={faBullseye} /></td>
                    <td>Asah</td>
                    <td>Membuka ruang perbaikan akhir</td>
                  </tr>
                  <tr>
                    <td><FontAwesomeIcon icon={faGlobe} /></td>
                    <td>Sebar</td>
                    <td>Membuka ruang menampilkan atau membagikan karya</td>
                  </tr>
                  <tr>
                    <td><FontAwesomeIcon icon={faPencilAlt} /></td>
                    <td>Menulis</td>
                    <td>Membuat atau mengedit naskah</td>
                  </tr>
                  <tr>
                    <td><FontAwesomeIcon icon={faPlus} /></td>
                    <td>Tambah</td>
                    <td>Menambahkan naskah atau scene</td>
                  </tr>
                  <tr>
                    <td><FontAwesomeIcon icon={faSave} /></td>
                    <td>Simpan</td>
                    <td>Menyimpan pekerjaan</td>
                  </tr>
                  <tr>
                    <td><FontAwesomeIcon icon={faPlay} /></td>
                    <td>Preview</td>
                    <td>Melihat hasil sementara</td>
                  </tr>
                  <tr>
                    <td><FontAwesomeIcon icon={faArrowLeft} /></td>
                    <td>Kembali</td>
                    <td>Kembali ke halaman sebelumnya</td>
                  </tr>
                  <tr>
                    <td><FontAwesomeIcon icon={faBell} /></td>
                    <td>Notifikasi</td>
                    <td>Menampilkan informasi sistem</td>
                  </tr>
                  <tr>
                    <td><FontAwesomeIcon icon={faUser} /></td>
                    <td>Profil</td>
                    <td>Melihat atau mengatur akun</td>
                  </tr>
                  <tr>
                    <td><FontAwesomeIcon icon={faSignInAlt} /></td>
                    <td>Login</td>
                    <td>Masuk ke akun pengguna</td>
                  </tr>
                  <tr>
                    <td><FontAwesomeIcon icon={faSignOutAlt} /></td>
                    <td>Logout</td>
                    <td>Keluar dari akun pengguna</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="subsection">
            <h4><FontAwesomeIcon icon={faQuestionCircle} /> B. Tips Cepat Penggunaan</h4>
            <p>Gunakan tips berikut agar penggunaan Website Rumah CERDAS berjalan lancar:</p>
            <div className="tips-grid">
              <div className="tip-card">
                <div className="tip-icon"><FontAwesomeIcon icon={faSave} /></div>
                <div className="tip-content">
                  <h5>Selalu Simpan</h5>
                  <p>Selalu klik Simpan sebelum berpindah menu dan simpan pekerjaan secara berkala</p>
                </div>
              </div>
              <div className="tip-card">
                <div className="tip-icon"><FontAwesomeIcon icon={faWifi} /></div>
                <div className="tip-content">
                  <h5>Koneksi Stabil</h5>
                  <p>Pastikan koneksi internet stabil saat menulis dan menyimpan</p>
                </div>
              </div>
              <div className="tip-card">
                <div className="tip-icon"><FontAwesomeIcon icon={faSync} /></div>
                <div className="tip-content">
                  <h5>Browser Terbaik</h5>
                  <p>Gunakan browser yang disarankan (Google Chrome / Mozilla Firefox)</p>
                </div>
              </div>
              <div className="tip-card">
                <div className="tip-icon"><FontAwesomeIcon icon={faSignOutAlt} /></div>
                <div className="tip-content">
                  <h5>Logout Aman</h5>
                  <p>Logout setelah selesai menggunakan website</p>
                </div>
              </div>
            </div>
            <div className="highlight-box">
              <h5>📌 Tips singkat:</h5>
              <p><strong>"Jika ragu, simpan dulu, baru lanjutkan."</strong></p>
            </div>
          </div>

          <div className="subsection">
            <h4><FontAwesomeIcon icon={faEnvelope} /> C. Kontak Bantuan Teknis</h4>
            <p>Jika pengguna mengalami kendala teknis yang tidak tercantum dalam manual ini, silakan menghubungi:</p>
            
            <div className="contact-info">
              <h5>Tim Pengembang Rumah CERDAS</h5>
              <div className="contact-item">
                <FontAwesomeIcon icon={faGlobe} />
                <span><strong>Website:</strong> https://digitalstorycerdas.id</span>
              </div>
              <div className="contact-item">
                <FontAwesomeIcon icon={faEnvelope} />
                <span><strong>Email:</strong> hanihandayani748@gmail.com</span>
              </div>
              <div className="contact-item">
                <FontAwesomeIcon icon={faPhone} />
                <span><strong>Kontak/WhatsApp:</strong> 08382866284</span>
              </div>
            </div>

            <div className="technical-note">
              <h5>📌 Saat menghubungi bantuan teknis, siapkan informasi berikut:</h5>
              <ul>
                <li>Nama pengguna</li>
                <li>Jenis perangkat (HP/Laptop)</li>
                <li>Browser yang digunakan</li>
                <li>Deskripsi singkat kendala yang dialami</li>
              </ul>
            </div>
          </div>

          <div className="closing-box">
            <p><em>Catatan: Lampiran ini disediakan untuk membantu pengguna mengoperasikan Website Rumah CERDAS secara cepat dan efisien.</em></p>
          </div>
        </div>
      ),
      subsections: ["A", "B", "C"]
    }
  ];

  return (
    <div className="panduan-container">
      <div className="panduan-header">
        <h2><FontAwesomeIcon icon={faBook} /> Manual Book Rumah CERDAS</h2>
        <p className="panduan-subtitle">Panduan lengkap penggunaan Website Rumah CERDAS dari awal hingga akhir</p>
      </div>

      <div className="panduan-content">
        {/* Sidebar Navigasi */}
        <div className="panduan-sidebar">
          <h3><FontAwesomeIcon icon={faBook} /> Daftar Isi</h3>
          <ul className="panduan-steps">
            {manualSections.map((section) => (
              <li 
                key={section.id}
                className={`panduan-step-item ${activeSection === section.id ? 'active' : ''}`}
                onClick={() => {
                  setActiveSection(section.id);
                }}
              >
                <div className="step-icon">
                  <FontAwesomeIcon icon={section.icon} />
                </div>
                <div className="step-info">
                  <h4>{section.title}</h4>
                  <p>{section.description || "Panduan penggunaan"}</p>
                </div>
                <FontAwesomeIcon icon={faChevronRight} className="step-arrow" />
              </li>
            ))}
          </ul>
          
          <div className="quick-tips-sidebar">
            <h4><FontAwesomeIcon icon={faQuestionCircle} /> Tips Cepat</h4>
            <ul>
              <li>Pilih bagian untuk melihat detail panduan</li>
              <li>Ikuti langkah sesuai urutan</li>
              <li>Simpan pekerjaan secara berkala</li>
              <li>Hubungi kami jika menemui kesulitan</li>
            </ul>
          </div>
        </div>

        {/* Konten Utama */}
        <div className="panduan-main">
          <div className="section-content">
            <div className="section-header">
              <span className="section-badge">Bagian {activeSection > 0 ? activeSection : "Pendahuluan"}</span>
              <h3>{manualSections[activeSection].title}</h3>
              {manualSections[activeSection].description && (
                <p className="section-description">{manualSections[activeSection].description}</p>
              )}
              {onOpenRoom && ROOM_LINKS_BY_SECTION[manualSections[activeSection].id] && (
                <div className="panduan-room-links">
                  {ROOM_LINKS_BY_SECTION[manualSections[activeSection].id].map(({ tab, label }) => (
                    <button
                      key={tab}
                      type="button"
                      className="panduan-room-btn"
                      onClick={() => onOpenRoom(tab)}
                    >
                      🚀 {label}
                    </button>
                  ))}
                </div>
              )}
            </div>
            
            <div className="section-body">
              {manualSections[activeSection].content}
            </div>

            <div className="section-navigation">
              <button 
                className="btn-prev"
                onClick={() => setActiveSection(prev => Math.max(0, prev - 1))}
                disabled={activeSection === 0}
              >
                <FontAwesomeIcon icon={faArrowLeft} /> Sebelumnya
              </button>
              <div className="section-progress">
                <span>Progress: {activeSection + 1} / {manualSections.length}</span>
                <div className="progress-bar">
                  <div 
                    className="progress-fill"
                    style={{ width: `${((activeSection + 1) / manualSections.length) * 100}%` }}
                  ></div>
                </div>
              </div>
              <button 
                className="btn-next"
                onClick={() => setActiveSection(prev => Math.min(manualSections.length - 1, prev + 1))}
                disabled={activeSection === manualSections.length - 1}
              >
                Selanjutnya <FontAwesomeIcon icon={faArrowRight} />
              </button>
            </div>

            <div className="panduan-tips">
              <h4><FontAwesomeIcon icon={faQuestionCircle} /> Informasi Penting</h4>
              <ul>
                <li>Ikuti panduan sesuai urutan untuk hasil terbaik</li>
                <li>Pastikan koneksi internet stabil saat menggunakan website</li>
                <li>Simpan pekerjaan sebelum berpindah halaman</li>
                <li>Gunakan browser Chrome atau Firefox untuk pengalaman optimal</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PanduanContent;